export const companySize = [ 
  {},
  {label: 'SMB', value: 'SMB'}, 
  {label: 'Mid Market', value: 'Mid Market'}, 
  {label: 'Enterprise', value: 'Enterprise'}
]